import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { v7 as uuid } from 'uuid';
import cx from 'classnames';
import useDebounce from '../../../hooks/use-debounce';
import Icon from '../icon';

import { ClearButton, Container, SearchInput, SearchLabel } from './search-bar.css';

function SearchBar(props) {
	const {
		initial = '',
		currentValue,
		onInput,
		placeholder = 'Search',
		canClear = true,
		isDisabled = false,
		className,
		filterFront = false,
		inputRef = null,
		cyName = null
	} = props;

	const [searchText, setSearchText] = useState(initial);

	const debouncedSearchText = useDebounce(searchText, 500);

	useEffect(() => {
		if( currentValue !== undefined && currentValue !== searchText ) {
			setSearchText(currentValue ?? '');
		}
	}, [currentValue]);

	useEffect(() => {
		if(searchText !== initial || filterFront || searchText === '') {
			onInput(searchText);
		}
	}, [debouncedSearchText]);

	const resetSearchText = () => {
		setSearchText('');
	};

	const resetOnEscape = (e) => {
		if( e.key !== 'Escape' ) {
			return;
		}

		if( !props.canClear ) {
			return;
		}

		resetSearchText();
	};

	const id = uuid();
	const classes = cx('px-search-bar', className);

	return (
		<Container className={classes}>
			<SearchInput
				id={id}
				value={searchText}
				placeholder={placeholder}
				disabled={isDisabled}
				onChange={(e) => setSearchText(e.target.value)}
				onKeyDown={resetOnEscape}
				data-testid="search-input"
				ref={inputRef}
				data-cy={cyName}
			/>

			<SearchLabel htmlFor={id}>
				<Icon use="search" color="white" />
			</SearchLabel>

			{searchText && canClear && (
				<ClearButton data-testid="search-clear" onClick={resetSearchText}>
					<Icon use="searchClose" color="white" size={0.8} />
				</ClearButton>
			)}
		</Container>
	);
}

SearchBar.propTypes = {
	initial: PropTypes.string,
	currentValue: PropTypes.string,
	onInput: PropTypes.func.isRequired,
	placeholder: PropTypes.string,
	canClear: PropTypes.bool,
	isDisabled: PropTypes.bool,
	filterFront: PropTypes.bool,
	className: PropTypes.string,
	inputRef: PropTypes.shape({ current: PropTypes.any }),
	cyName: PropTypes.string
};

export default SearchBar;
